(function () {
  function initInteriorShowcase(root) {
    if (!root || root.dataset.interiorShowcaseInitialized === 'true') return;

    root.dataset.interiorShowcaseInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-interior-open]'));
    var lightbox = root.querySelector('[data-interior-lightbox]');
    var media = root.querySelector('[data-interior-lightbox-media]');
    var img = root.querySelector('[data-interior-lightbox-image]');
    var title = root.querySelector('[data-interior-lightbox-title]');
    var caption = root.querySelector('[data-interior-lightbox-caption]');
    var count = root.querySelector('[data-interior-lightbox-count]');
    var prevBtn = root.querySelector('[data-interior-prev]');
    var nextBtn = root.querySelector('[data-interior-next]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-interior-close]'));
    var currentIndex = 0;

    if (!triggers.length || !lightbox || !img) return;

    function moveLightboxToBody() {
      if (lightbox.parentNode !== document.body) {
        document.body.appendChild(lightbox);
      }
    }

    function getItem(index) {
      return triggers[index];
    }

    function render(index) {
      var item = getItem(index);

      if (!item) return;

      currentIndex = index;

      img.src = item.getAttribute('data-interior-image') || '';
      img.alt = item.getAttribute('data-interior-title') || 'Imagen del interior';

      if (title) {
        title.textContent = item.getAttribute('data-interior-title') || '';
      }

      if (caption) {
        caption.textContent = item.getAttribute('data-interior-caption') || '';
      }

      if (count) {
        count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(triggers.length).padStart(2, '0');
      }
    }

    function openLightbox(index) {
      moveLightboxToBody();
      render(index);

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('interior-showcase-modal-open');
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('interior-showcase-modal-open');
    }

    function next() {
      var nextIndex = (currentIndex + 1) % triggers.length;
      render(nextIndex);
    }

    function prev() {
      var prevIndex = (currentIndex - 1 + triggers.length) % triggers.length;
      render(prevIndex);
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeLightbox();
      });
    });

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (lightbox.hidden) return;

        var clickedClose = event.target.closest('[data-interior-close]');
        var clickedInsideMedia = media && media.contains(event.target);

        if (clickedClose || !clickedInsideMedia) {
          closeLightbox();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        next();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        prev();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
      }

      if (event.key === 'ArrowRight') {
        next();
      }

      if (event.key === 'ArrowLeft') {
        prev();
      }
    });
  }

  function initAllInteriorShowcases() {
    var roots = document.querySelectorAll('[data-interior-showcase-root]');

    roots.forEach(function (root) {
      initInteriorShowcase(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInteriorShowcases);
  } else {
    initAllInteriorShowcases();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-interior-showcase-root]');

    if (root) {
      root.dataset.interiorShowcaseInitialized = 'false';
      initInteriorShowcase(root);
    }
  });
})();